module.exports = __webpack_public_path__ + "img/qred@2x.3964a01.png";